import './src/styles/global.css'
import * as Sentry from '@sentry/gatsby'

if (typeof window !== 'undefined') {
  // eslint-disable-next-line no-undef
  window.DEV_EXTENSIONS_MODE = process.env.DEV_EXTENSIONS_MODE
}

function shouldEnableSentry() {
  if (process.env.DEV_EXTENSIONS_MODE) return false
  if (process.env.GATSBY_SENTRY_ENV === 'production') return true

  return process.env.GATSBY_SENTRY_ENABLE === 'true'
}

if (shouldEnableSentry()) {
  Sentry.init({
    dsn: process.env.GATSBY_SENTRY_DSN_URL,
    environment: process.env.GATSBY_SENTRY_ENV,
    integrations: [Sentry.browserTracingIntegration()],
    // Performance Monitoring
    tracesSampleRate: 1.0, //  Capture 100% of the transactions

    // If release is undefined, Sentry will use the commit hash when sending
    // events
    release: process.env.GATSBY_SENTRY_RELEASE,

    // These errors will not be sent to sentry
    ignoreErrors: [
      // Ignore react-id-swipper inconsistent error
      /Cannot read properties of undefined (reading 'isTouched')/,
      // Ignore abort errors from rest and graphql requests
      /AbortError: The user aborted a request/,
    ],

    // We need the following because sourcemaps don't contain a full URL or
    // base paths, only the pathname.
    //
    // See:
    // https://docs.sentry.io/platforms/javascript/guides/node/legacy-sdk/sourcemaps/#updating-raven-configuration-to-support-source-maps
    // https://github.com/getsentry/sentry-javascript/issues/1406
    beforeSend(event) {
      const stacktrace = event.exception && event.exception.values[0].stacktrace

      if (stacktrace && stacktrace.frames) {
        stacktrace.frames.forEach((frame) => {
          if (!frame.filename.startsWith('http')) {
            return
          }

          // parse filename as url
          let { pathname } = new URL(frame.filename)

          if (pathname.startsWith('/assisted-sales')) {
            pathname = pathname.replace(/^\/assisted-sales/, '')
          }

          if (pathname.startsWith('/sales-app')) {
            pathname = pathname.replace(/^\/sales-app/, '')
          }

          frame.filename = pathname
        })
      }

      return event
    },
  })
}
